import { fwuVersionsUtil } from "../../../../../utils";
import { versionUtils } from "./versionUtils";

const filterVersionOptions = (versionOptions, prevVersion, nextVersion) => {
  let filteredOptions = versionOptions;

  if (prevVersion) {
    filteredOptions = filteredOptions?.filter((verion) =>
      versionUtils.compareVersions(
        fwuVersionsUtil.splitVersion(verion?.value),
        fwuVersionsUtil.splitVersion(prevVersion)
      )
    );
  }

  if (nextVersion) {
    filteredOptions = filteredOptions?.filter((verion) =>
      versionUtils.compareVersions(
        fwuVersionsUtil.splitVersion(nextVersion),
        fwuVersionsUtil.splitVersion(verion?.value)
      )
    );
  }

  return filteredOptions;
};

export const versionOptionUtils = {
  filterVersionOptions
};
